import Vue from 'vue'
import moment from 'moment'

Vue.filter('priceFormat', function(value) {
  try {
    if (value === '-') {
      return '-'
    }
    // 預留最多10位顯示 //
    return parseFloat(value).toLocaleString("zh-TW", { maximumFractionDigits : 10 })
  } catch (error) {
    return value
  }
})

Vue.filter('dateFormat', function(value) {
  try {
    if (value instanceof Date) {
      return moment(value).format('YYYY/MM/DD')
    } else {
      const microsecond = value * 1000
      const date = new Date(microsecond)
      return moment(date).format('YYYY/MM/DD')
    }
  } catch (error) {
    return value
  }
})

Vue.filter('dateTimeFormat', function(value) {
  try {
    if (value instanceof Date) {
      return moment(value).format('MM/DD HH:mm')
    } else {
      const microsecond = value * 1000
      const date = new Date(microsecond)
      return moment(date).format('MM/DD HH:mm')
    }
  } catch (error) {
    return value
  }
})

Vue.filter('fullDateTimeFormat', function(value) {
  try {
    if (value instanceof Date) {
      return moment(value).format('YYYY-MM-DD HH:mm:ss')
    } else {
      const microsecond = value * 1000
      const date = new Date(microsecond)
      return moment(date).format('YYYY-MM-DD HH:mm:ss')
    }
  } catch (error) {
    return value
  }
})

Vue.filter('FundsTimeFormat', function(value) {
  try {
    if (value instanceof Date) {
      return moment(value).format('YYYY-MM-DD HH:mm:ss')
    } else {
      const microsecond = value * 1000
      const date = new Date(microsecond)
      return moment(date).format('YYYY-MM-DD HH:mm:ss')
    }
  } catch (error) {
    return value
  }
})

Vue.filter('productDetailFormat', function(value, className) {
  try {
    return value
      .replace(new RegExp('【', 'gm'), '<div class="' + className + '">【')
      .replace(new RegExp('】', 'gm'), '】</div>')
  } catch (error) {
    return `${value} ${className}`
  }
})

Vue.filter('pricename', function(value) {
  try {
    if (!value || value === '單一價') return ''
    return `- ${value}`
  } catch (error) {
    return value
  }
})

Vue.filter('currencyTitle', function(currencyCode) {
  try {
    switch (currencyCode) {
      case 'TWD': return 'NT$'
      case 'USD': return 'US$'
      case 'JPY': return 'JP¥'
    }
    return currencyCode
  } catch (error) {
    return currencyCode
  }
})
